import microservices from '@r1-frontend/do-request/microservices.json';
import getAccessToken from '@r1-frontend/shared/helpers/getAccessToken';
import getProviderId from '@r1-frontend/shared/helpers/getProviderId';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';
var BaseRequest = /** @class */ (function () {
    function BaseRequest() {
        this.config = {
            microservices: microservices,
        };
        this.config.ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIROMENT || 'production';
    }
    BaseRequest.prototype.getCurrentServiceConfig = function (serviceName) {
        var currentServiceConfig = this.config.microservices.find(function (config) { return config.name === serviceName; });
        if (!currentServiceConfig) {
            throw new Error("Unknown service name " + serviceName);
        }
        return currentServiceConfig;
    };
    BaseRequest.prototype.getDefaultHeaders = function (withAuth, withProvider) {
        var defaultHeaders = {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        };
        if (withAuth) {
            defaultHeaders['Authorization'] = "Bearer " + getAccessToken();
        }
        if (withProvider) {
            defaultHeaders['ProviderId'] = getProviderId();
        }
        return defaultHeaders;
    };
    BaseRequest.prototype.getBaseUrl = function (serviceName) {
        var _a = this.getCurrentServiceConfig(serviceName), devUrl = _a.devUrl, prodUrl = _a.prodUrl, proxyPort = _a.proxyPort, devInnerUrl = _a.devInnerUrl, prodInnerUrl = _a.prodInnerUrl;
        var environment = this.config.ENVIRONMENT;
        var isSsr = isServerSide();
        switch (true) {
            case environment === 'localhost':
                return proxyPort ? "http://localhost:" + proxyPort : devUrl;
            case environment === 'sandbox' && isSsr:
                return devInnerUrl || devUrl;
            case environment === 'sandbox' && !isSsr:
                return devUrl;
            case environment === 'production' && isSsr:
                return prodInnerUrl || prodUrl;
            default:
                return prodUrl;
        }
    };
    return BaseRequest;
}());
export default BaseRequest;
